module.exports = __webpack_public_path__ + "media/images/photography/sub-nav-cm-e411f9d2023f93dc965899ff671bda5b.jpg";